import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import connect from "nexia_mobile/flux_like/store/connect";
import Page from "nexia_mobile/components/Page";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";
import OverlayLinearProgress from "nexia_mobile/components/OverlayLinearProgress";
import safelyOpen from "nexia_mobile/safelyOpen";

const NoDevicesPage = ({ appBar, showDeviceAdd, backgroundLoading }) => (
  <Page name="NoDevicesPage" fullyLoaded>
    {appBar}
    {backgroundLoading && <OverlayLinearProgress indeterminate />}
    <ScrollableArea>
      <div
        style={{
          padding: "0 0.75em",
          maxWidth: "25em",
          margin: "0.75em auto",
        }}
      >
        <p>
          With Nexia, you have the flexibility to monitor and control your
          home&apos;s smart devices.
        </p>
        <p>
          If you already have your devices, select the &apos;Connect New
          Device&apos; button below to begin connecting your devices to Nexia.
        </p>
        <div style={{ textAlign: "center" }}>
          <Button theme="ghost" onTap={showDeviceAdd}>
            Connect New Device
          </Button>
        </div>
        <p>
          For more information about devices that work with Nexia, go to our
          &apos;Compatible Products&apos; page.
        </p>
        <div style={{ textAlign: "center" }}>
          <Button
            theme="ghost"
            needsTrustedTap
            onTap={() => {
              safelyOpen("http://www.nexiahome.com/compatible-products/");
            }}
          >
            Compatible Products
          </Button>
        </div>
      </div>
    </ScrollableArea>
  </Page>
);
NoDevicesPage.propTypes = {
  appBar: PropTypes.element.isRequired,
  showDeviceAdd: PropTypes.func,
  backgroundLoading: PropTypes.bool.isRequired,
};

export default connect(
  {
    backgroundLoading: "backgroundLoading",
  },
  NoDevicesPage
);



// WEBPACK FOOTER //
// ./src/components/Pages/NoDevicesPage.jsx